(function () {
  var root = document.querySelector("[data-gridlock-landing]");
  if (!root) return;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var targets = root.querySelectorAll(".gg-section, .gg-card, .gg-before-after article, .gg-step-list li");

  if (!reduceMotion && "IntersectionObserver" in window) {
    targets.forEach(function (target) {
      target.classList.add("gg-reveal");
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    targets.forEach(function (target) {
      observer.observe(target);
    });
  }
})();
